export const printingQuantity = ['1', '9', '25', '100', '250', '500', '750', '1000'];

export const embroideryQuantity = ['1', '9', '25', '100', '250', '500', '750', '1000'];

export const bigBackTypes = ['Printing', 'Embroidery'];

export const printingPrices = ['£7.99', '£5.99', '£4.50', '£3.50', '£2.50', '£2.00', '£1.50', '£1.25'];

export const irishPrintingPrices = ['€8.32', '€6.25', '€4.46', '€3.57', '€2.38', '€2.08', '€1.49', '€1.19'];

export const embroideryPrices = ['£7.99', '£6.25', '£4.75', '£3.75', '£2.75', '£2.25', '£1.75', '£1.25'];

export const irishEmbroideryPrices = ['€8.32', '€6.55', '€4.76', '€3.87', '€2.68', '€2.08', '€1.49', '€1.19'];

export const bigBackPrice = ['£7.99', '£8.95'];

export const irishBigBackPrice = ['€8.27', '€10.65'];

export const setupTypes = ['Printed Text', 'Embroidered Text', 'Printed Logo', 'Embroidered Logo'];

export const setupCosts = ['£4.95', '£4.95', '£8.95', '£8.95'];

export const irishSetupCosts = ['€5.89', '€5.89', '€10.65', '€10.65'];

export const extrasNames = ['Inside printed neck label', 'Garments Individually Bagged', 'Retail Ready Packaging '];

export const extrasDescriptions = [
    "We offer the service of printing your label inside the back position of specific garments. While we are unable to remove the manufacturer's label for you, opting for printed labels presents an excellent opportunity to infuse your clothing with your brand's identity.",
    'Should you desire each item to be individually bagged, we offer this service to cater to your needs. While all the items will still be dispatched together in the same outer packaging, every single item within the package will be securely placed in its own clear poly bag.',
    "If you're looking for retail-ready packaging for your garments, we have the perfect solution for you. Our comprehensive service includes attaching a neck label, placing each garment in a clear poly bag, and adding a barcode (if required), along with a price tag. This retail-ready packaging is available, providing you with a professional and cohesive presentation that's ready for the retail environment.",
];
